import { Box, Flex, Text, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreItem, type CoreInsurance } from '@flecto/types'
import { AvatarItem, TextCopy } from '@flecto/ui'

export type CellNameProps = {
  insurance?: CoreInsurance
}

export function CellName({ insurance }: CellNameProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  return (
    <Flex align='center' gap='sm' style={{ overflow: 'hidden' }}>
      <AvatarItem size='sm' item={insurance?.item as CoreItem} />
      <Box maw={250} mt={-3}>
        <Box style={{ overflow: 'hidden' }}>
          <Text fw={500} truncate>
            {insurance?.item?.title ?? '-'}
          </Text>
          <Tooltip
            label={`${t('table.label_policy_number')}: ${insurance?.policy_number}`}
            withinPortal
          >
            <Flex gap='xs' align='center' wrap='nowrap' c='dimmed'>
              <Text
                size='sm'
                style={{
                  flexShrink: 0,
                }}
              >
                {t('table.cell_name_quantity', {
                  replace: { quantity: insurance?.quantity },
                })}
              </Text>

              <Text
                c='dimmed'
                size='sm'
                style={{
                  flexShrink: 0,
                }}
              >
                {t('table.label_policy_number')}:
              </Text>

              <TextCopy size='sm'>{insurance?.policy_number}</TextCopy>
            </Flex>
          </Tooltip>
        </Box>
      </Box>
    </Flex>
  )
}
